import { typesValidation } from '../../common/types';
import { validInputEmail } from './validateInput';

const { validateEmail } = typesValidation;

export const validFormContacto = user => {
  const dataResponse = {
    isValid: true,
    msgValid: {
      errors: null,
      success: null,
    },
  };
  let isValid = true;
  let inputsError = {
    correo: '',
    telefono: '',
  };
  let inputsSuccess = {
    correo: false,
    telefono: false,
  };

  if (!user.correo) {
    inputsError.correo = 'Correo del contacto no ha sido asignado.\n';
    inputsSuccess.correo = false;
    isValid = false;
  }

  if (!inputsError.correo && !validInputEmail(user.correo, validateEmail)) {
    inputsError.correo = 'Correo no válido.\n';
    inputsSuccess.correo = false;
    isValid = false;
  }

  if (!user.telefono) {
    inputsError.telefono = 'Telefono del contacto no ha sido asignado.\n';
    inputsSuccess.telefono = false;
    isValid = false;
  }

  dataResponse.isValid = isValid;
  dataResponse.msgValid.errors = inputsError;
  dataResponse.msgValid.success = inputsSuccess;
  return dataResponse;
};
